import script from "./DisConnectDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DisConnectDialog.vue?vue&type=script&setup=true&lang=js"

import "./DisConnectDialog.vue?vue&type=style&index=0&id=36279bd6&lang=scss"

const __exports__ = script;

export default __exports__